<template>
  <div class="container" id="referee_detail_outer" v-if="item != null">
    <h3 style="margin-top: 50px;">认证裁判员</h3>
    <div class="referee-information-outer">
      <a class="return-to-list" href="javascript:void(0)" v-on:click="goBackToList"><<返回列表</a>
      <div class="referee-information">
        <div class="left-view">
          <div class="img-view">
            <el-image v-if="item.headPortrait != null && item.headPortrait.length > 0" class="user-image" fit="cover" :src="item.headPortrait" :preview-src-list="[item.headPortrait]" />
            <el-image v-else class="user-image" fit="cover" :src="defaultHeaderImage" />
            <div v-show="isCompleted(item)" :class="['status-label', 'active']">本年度年审合格</div>
          </div>
        </div>
        <div class="right-view">
          <div class="nickname">{{item.name}}</div>
          <div class="sub-row-view">
            <div><strong>性别：</strong>{{item.sex}}</div>
            <div><strong>所属区域：</strong>{{'上海市' + item.area}}</div>
            <div><strong>裁判员等级：</strong>{{item.certificateLevel}}</div>
            <div><strong>现级别批准年份：</strong>{{ item.yearOfApproval + '年'}}</div>
<!--            <div v-if="item.experience != null && item.experience.length > 0">-->
<!--              <div style="color: #333;"><strong>执裁经历: </strong></div>-->
<!--              <div class="experience-view" v-html="item.experience"></div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userDefaultGoldIcon from '../assets/shl_personal_head_portrait_gold_default.png'
  import userDefaultRedIcon from '../assets/shl_personal_head_portrait_red_default.png';
export default {
  name: "RefereeDetailPage",
  data() {
    return {
      item: null,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    refereeId() {
      return this.$route.params.refereeId;
    },
    isVip() {
      let item = this.item;
      if (item == null) {
        return false;
      }
      let member = item.isMember;
      if (member != undefined && member > 0) {
        return true;
      }
      return false;
    },

    defaultHeaderImage() {
      return this.isVip ? userDefaultGoldIcon : userDefaultRedIcon;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    isCompleted(item) {
      let status = item.status;
      let staminaTest = item.staminaTest;
      let theoryTest = item.theoryTest;
      let bothTrue = false;
      if (staminaTest == '已通过' && theoryTest == '已通过') {
        bothTrue = true;
      }

      if ((status == 5 && bothTrue) || status == 6) {
        return true;
      }
      return false;
    },

    getYearFromDate(date) {
      let myDate =  new Date(date);
      return myDate.getFullYear()
    },

    goBackToList() {
      this.$router.go(-1);
    },
    loadData() {
      let id = this.refereeId;
      let _this = this;
      this.httpManager.ajax.getJudgeDetailData(id, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.item = data.data;
        } else  {
          _this.$toast("请求失败！");
        }

      }, function (data) {
        _this.$toast("请求失败！");
      })
    },
  }
}
</script>

<style scoped>

  #referee_detail_outer .referee-information-outer {
    margin-top: 50px;
    border: solid 1px #fc1a34;
    padding: 15px 15px 50px 15px;
    /*min-height: 300px;*/
    text-align: left;
  }

  .referee-information-outer .return-to-list {
    text-decoration: none;
    color: #999;
  }

  .referee-information-outer .return-to-list:hover {
    color: #fc1a34;
  }

  #referee_detail_outer .referee-information {
    margin-top: 30px;
    /*min-height: 300px;*/
    /*background-color: yellow;*/
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  .referee-information > div {
    width: 100%;
  }

  .referee-information .left-view {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: flex-start;
    padding-bottom: 15px;
  }

  .referee-information .img-view {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .referee-information .user-image {
    width: 150px;
    height: 150px;
    background-color: white;
    border-radius: 75px;
  }

  .referee-information .status-label {
    font-size: smaller;
    color: gray;
    border: solid 1px gray;
    text-align: center;
    margin-top: 10px;
    vertical-align: middle;
    padding: 2px 10px;
  }

  .referee-information .status-label.active {
    color: green;
    border: solid 1px green;
  }

  .referee-information .right-view {
    min-width: 220px;
    width: 100%;
    padding-top: 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .referee-information .sub-row-view {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    font-size: 1rem;
    color: #333;
  }

  .referee-information .nickname {
    font-size: 1.5rem;
    color: #333;
  }

  .referee-information .experience-view {
    width: 100%;
    font-size: 1rem;
    margin-top: 3px;
    color: #333;
  }

  .referee-information .sub-row-view > div {
    margin-top: 7px;
  }
  .referee-information .sub-row-view > div:first-child {
  }
  .referee-information .sub-row-view > div:not(:first-child) {
    /*width: 100%;*/
    /*background-color: red;*/
  }

  @media screen and (min-width: 768px){
    #referee_detail_outer .referee-information {
      flex-wrap: nowrap;
      justify-content: flex-start;
    }

    .referee-information .left-view {
      justify-content: flex-end;
      padding-bottom: 0px;
      width: 50%;
    }

    .referee-information .img-view {
      margin-right: 30px;
    }
    .referee-information .right-view {
      width: 50%;
      text-align: left;
      align-items: flex-start;
    }

    .referee-information .sub-row-view {
      flex-wrap: nowrap;
    }

    .referee-information .sub-row-view > div:first-child {
      /*width: 40%;*/
    }
    .referee-information .sub-row-view > div:not(:first-child) {
      /*width: 60%;*/
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/RefereeDetailPage.vue